<template>
  <div>
    <menubar>
      <template #rightItems>
        <b-dropdown class="p-3" toggle-class="btn-icon mono" right no-caret>
          <template #button-content><i class="mdp-Options" data-cy="attribute-manager-contextmenu-icon"></i></template>
          <b-dropdown-item link-class="icon-item" v-b-modal.view-options-modal>
            <div class="dd-item-container" data-cy="attribute-manager-contextmenu-view-button">
              <span class="dd-item-icon"><i class="mdp-Preview" /></span>
              <span class="dd-item-text"> {{ $t("menubar.view") }}... </span>
            </div>
          </b-dropdown-item>
          <b-dropdown-item link-class="icon-item" v-b-modal.general-options-modal>
            <div class="dd-item-container" data-cy="attribute-manager-contextmenu-options-button">
              <span class="dd-item-icon"> <i class="mdp-Settings" /> </span>
              <span class="dd-item-text"> {{ $t("options") }}... </span>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </menubar>
    <view-options-modal></view-options-modal>
    <general-options-modal></general-options-modal>
  </div>
</template>

<script>
import menubar from "../../common/components/MenuBar/MenuBar.vue";
import viewOptionsModal from "../components/OptionsMenus/ViewOptionsModal.vue";
import generalOptionsModal from "../components/OptionsMenus/GeneralOptionsModal.vue";

export default {
  components: {
    menubar,
    viewOptionsModal,
    generalOptionsModal
  }
};
</script>
